import React from "react";
import "./Footer.css";
import xt from "../../assests/footer-logo.svg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import india from "../../assests/Footer/india.svg";
import us from "../../assests/Footer/united-states.svg";
import facebook from "../../assests/Footer/Facebook.svg";
import insta from "../../assests/Footer/Instagram.svg";
import link from "../../assests/Footer/LinkedIn.svg";
import youtube from "../../assests/Footer/YouTube.svg";
import isoimg from "../../assests/Footer/iso-img.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll function
  const scrollToSection = (id: string) => {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        const offset = 100;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    }, 300); // delay ensures DOM is ready after navigation
  };

  // Navigate + scroll
  const handleNavigateAndScroll = (path: string, id: string) => {
    if (location.pathname !== path) {
      navigate(path);
      scrollToSection(id);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <footer className="footer text-white pt-5 pb-4">
      <div >
        <div className="row gy-4">
          {/* Logo & Contact Info */}
          <div className="col-12 col-lg-4">
            <div className="logo-section">
              <img src={xt} alt="Xyloite Logo" className="mb-3 footer-logo" />
            {/* ISO Image */}
            <div className="iso-section mt-0 mb-2">
              <img src={isoimg} alt="ISO Certification" className="iso-image" />
            </div>
              <p className="tagline-text mb-4">
                Partner with Xyloite to transform your business with next-gen AI
                and smart IT solutions.
              </p>
            </div>

            {/* Contact Info */}
            <div className="contact-row">
              <div className="contact-column">
                <p className="contact-info">
                  <strong>For Sales</strong>
                  <br />
                  <span className="contact-item">
                    <i className="bi bi-envelope me-2"></i>
                    <a href="mailto:hello@xyloite.com">hello@xyloite.com</a>
                  </span>
                  <br />
                  <span className="contact-item mt-3">
                    <i className="bi bi-telephone me-2"></i> +91 78128 07079
                  </span>
                </p>
              </div>

              <div className="contact-column">
                <p className="contact-info">
                  <strong>For Career</strong>
                  <br />
                  <span className="contact-item">
                    <i className="bi bi-envelope me-2"></i>
                    <a href="mailto:hr@xyloite.com">hr@xyloite.com</a>
                  </span>
                  <br />
                  <span className="contact-item mt-3">
                    <i className="bi bi-telephone me-2 "></i> +91 9600910450
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-6 col-lg-2">
            <h5 className="footer-heading">Quick Link</h5>
            <ul className="list-unstyled footer-links">
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateAndScroll("/", "home");
                  }}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateAndScroll("/", "about");
                  }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateAndScroll("/", "services");
                  }}
                >
                  Service
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateAndScroll("/", "product");
                  }}
                >
                  Product
                </a>
              </li>
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateAndScroll("/", "career");
                  }}
                >
                  Career
                </a>
              </li>
              <li>
                <Link to="/Contact-Us">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="col-6 col-lg-3">
            <h5 className="footer-heading">Social Media</h5>
            <ul className="list-unstyled footer-links">
              <li className="social-link">
                <a href="https://www.linkedin.com/company/xyloite-technologies/" target="_blank" rel="noopener noreferrer">
                  <img src={link} alt="LinkedIn" className="social-icon me-2" /> LinkedIn
                </a>
              </li>
              <li className="social-link">
                <a href="https://www.instagram.com/xyloite_technologies_24" target="_blank" rel="noopener noreferrer">
                  <img src={insta} alt="Instagram" className="social-icon me-2" /> Instagram
                </a>
              </li>
              <li className="social-link">
                <a href="https://www.facebook.com/share/16WBuLeVBb/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} alt="Facebook" className="social-icon me-2" /> Facebook
                </a>
              </li>
              <li className="social-link">
                <a href="https://youtube.com/@xyloitetechnologies?si=Fp0GDPmHDrEIz0yD" target="_blank" rel="noopener noreferrer">
                  <img src={youtube} alt="YouTube" className="social-icon me-2" /> YouTube
                </a>
              </li>
            </ul>
          </div>

          {/* Location Info */}
          <div className="col-12 col-lg-3">
            <h5 className="footer-heading">Location</h5>
            <div className="location-item mb-4">
              <img src={india} alt="India" className="country-flag mb-2" />
              <p className="location-text">
                No 15, Lakshmi Gardens, Ramakrishna Puram, Ganapathi,
                <br /> Coimbatore, Tamil Nadu. - 641006
              </p>
            </div>
            <div className="location-item">
              <img src={us} alt="US" className="country-flag mb-2" />
              <p className="location-text">
                539 W.Commerce St#403
                <br /> Dallas, Tx 75208
                <br /> USA. (+1 313 444 7009)
              </p>
            </div>
          </div>
        </div>

        <hr className="footer-divider mt-5 mb-4" />
        <div className="text-center">
          <p className="copyright-text mb-0">
            Copyright © 2025 Xyloite Technologies | All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
